import type { HttpTypes } from '@medusajs/types';

import { isCashOnlyProductVariant } from './is-cash-only-product-variant';
import { convertToLocale } from './money';

export const getCheckoutPrice = (cart: HttpTypes.StoreCart | null) => {
  if (!cart || !cart.items?.length) {
    return {
      item_total: null,
      subtotal: null,
      discount_total: null,
      shipping_total: null,
      total: null,
      total_price_number: 0,
      shipping_total_number: 0,
      cashOnlyItemTotalNumber: 0,
      nonCashOnlyItemTotalNumber: 0,
    };
  }

  // Calculate cash_only item category totals
  const { cashOnlyItemTotalNumber, nonCashOnlyItemTotalNumber } =
    cart.items.reduce(
      (acc, item) => {
        const itemTotal = item.unit_price * item.quantity;

        if (isCashOnlyProductVariant(item.variant)) {
          return {
            ...acc,
            cashOnlyItemTotalNumber: acc.cashOnlyItemTotalNumber + itemTotal,
          };
        } else {
          return {
            ...acc,
            nonCashOnlyItemTotalNumber:
              acc.nonCashOnlyItemTotalNumber + itemTotal,
          };
        }
      },
      { cashOnlyItemTotalNumber: 0, nonCashOnlyItemTotalNumber: 0 }
    );

  return {
    item_total: convertToLocale({
      amount: cart?.item_total ?? 0,
      currency_code: cart?.currency_code as string,
    }),
    subtotal: convertToLocale({
      amount: cart?.subtotal ?? 0,
      currency_code: cart?.currency_code as string,
    }),
    discount_total: convertToLocale({
      amount: cart?.discount_total ?? 0,
      currency_code: cart?.currency_code as string,
    }),
    shipping_total: convertToLocale({
      amount: cart?.shipping_total ?? 0,
      currency_code: cart?.currency_code as string,
    }),
    total_price_number: cart?.total,
    shipping_total_number: cart?.shipping_total ?? 0,
    total: convertToLocale({
      amount: cart?.total ?? 0,
      currency_code: cart?.currency_code as string,
    }),
    cashOnlyItemTotalNumber,
    nonCashOnlyItemTotalNumber,
  };
};
